if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;

(function () {

    //Api weather
	// if ((location.pathname == "/florida-resident") || (location.pathname == "/es/residente-de-florida") || (location.pathname == "/pt/residente-na-florida")) {
	// 	weather(); 
	// }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $('.easy-scroll').click(function () {
        var target = $(this).attr("href");
        if ($('body.main').length > 0) { var padding = 0; } else { var padding = $('header').height() / 2; }
        $('html, body').animate({ scrollTop: $(target).offset().top - padding }, 1500);
        return false;
    });

    $('.sym-slides').slick({
        accessibility: false,
    }); 

    $('.hero__slider').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000
    });

    $('.module__slider').each(function(i){

        let mySlider = $(this);
        let dotscontainer = mySlider.siblings('.module__dots')

        mySlider.slick({
            arrows: false,
            dots: true,
            fade: true,
            appendDots: dotscontainer,
            customPaging: function (slider , i) {
                
                var title = $(slider.$slides[i]).data('tag');
                title = title.replace("-"," ");
              
                return '<span class="module__tag"> ' + title + ' </span>';
            },
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    })
    $('.module--d .module__dots .module__tag').click(function(){
        $(this)
        .closest('.sym-slides')
        .slick("slickGoTo", $(this).parent().index());
    });
    

    $('.awards-module__group').slick({
        arrows: false,
        dots: true,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        infinite: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 400,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    });
    $('.column-slider__group').slick({
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        infinite: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    });

    //funtion accordion module 
    document.querySelectorAll('.accordion-module__trigger').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.stopPropagation(); 

            const currentTrigger = e.currentTarget; 
            const content = currentTrigger.nextElementSibling; 

            currentTrigger.classList.toggle('active');

            if (content && content.classList.contains('accordion-module__content')) {
                content.classList.toggle('active');
            }
            closeOthers(currentTrigger, '.accordion-module__item');
        });
    });

    //funtion second accordion module
    document.querySelectorAll('.accordion-module__second-trigger h3').forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.stopPropagation();

            const currentTrigger = e.currentTarget; 
            const content = currentTrigger.parentElement.querySelector('.accordion-module__second-copy');

            currentTrigger.classList.toggle('active');


            if (content) {
                content.classList.toggle('active');
            }

            closeOthers(currentTrigger, '.accordion-module__second-trigger');
        });
    });

    //close others accordion module
    function closeOthers(currentTrigger, scopeSelector) {
        const parentItem = currentTrigger.closest(scopeSelector);

        if (parentItem) {
            parentItem.querySelectorAll('.accordion-module__trigger, .accordion-module__second-trigger h3').forEach(trigger => {
                if (trigger !== currentTrigger) {
                    trigger.classList.remove('active');
                    const siblingContent = trigger.parentElement.querySelector('.accordion-module__content, .accordion-module__second-copy');
                    if (siblingContent) {
                        siblingContent.classList.remove('active');
                    }
                }
            });
        }
    }

    //close all accordion module
    function closeAll() {
        document.querySelectorAll('.accordion-module__trigger, .accordion-module__second-trigger h3').forEach(trigger => {
            trigger.classList.remove('active');
            const siblingContent = trigger.parentElement.querySelector('.accordion-module__content, .accordion-module__second-copy');
            if (siblingContent) {
                siblingContent.classList.remove('active');
            }
        });
    }
    
    //end funtion accordion module



    // Fancybox options
    $('.fancybox').fancybox();

    $('.fancybox-module').fancybox({
        maxWidth: 800,
        wrapCSS: 'module__popup-wrapper'
        
    });$('.fancybox-custom').fancybox({
        maxWidth: 1200,
        wrapCSS: 'module__popup-wrapper'
    });

    $('.fancybox-form').fancybox({
        maxWidth: 1170,
        wrapCSS: 'module__popup-wrapper'
    });

    window.onload = function () {
        scrollW();
        window.addEventListener('scroll', function () {
            scrollW();
        })
    }
    function scrollW() {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > 0) {
            if (st > lastScrollTop) {
                // downscroll code
                if (!document.getElementById('header').classList.contains('down')) {
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }
            } else {
                // upscroll code
                if (!document.getElementById('header').classList.contains('up')) {
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }
        } else {
            if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
    
    if( langSelected != "en" ){

        var site_url_aux = site_url.replace( langSelected + "/", "" );
    
        $( "#privary-navigation a" ).each( function( index, value ){

            if( $( this ).attr( "href" ).indexOf( "/" + langSelected + "/" ) == "-1" ){


                if( $( this ).attr( "href" ).indexOf( site_url_aux ) != "-1" ){
                    
                    let href = $( this ).attr( "href" ).replace( site_url_aux, site_url_aux + langSelected + "/" )
                    $( this ).attr( "href", href )
                    
                }else if( $( this ).attr( "href" ).indexOf( "http" ) == "-1" ){
                    
                    $( this ).attr( "href", "/" + langSelected + $( this ).attr( "href") )
                    
                }    

            }

        } )

    }
    
    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

})();
